import { useIntl } from 'react-intl';

import { Layout } from '~/eds/src/components/Layout/Layout';
import { TextInput } from '~/eds/src/components/TextInput/TextInput';
import { Nullable } from '~/types/Nullable';

import { BaseFilter } from './VisibilityFilter';

type ShareFilters = 'PRIVATE' | 'SHARED';

interface SearchAndFiltersProps {
  search: string;
  visibility: Nullable<ShareFilters>;
  onFilter?: (updatedValue: Nullable<ShareFilters>) => void;
  onSearch: (updatedValue: string) => void;
}

export const SearchAndFilters = ({
  search,
  visibility,
  onSearch,
  onFilter,
}: SearchAndFiltersProps) => {
  const intl = useIntl();

  const visibilityText = !visibility
    ? intl.formatMessage({
        id: 'SearchAndFilters.shareStatus',
        defaultMessage: 'Share status',
        description: 'Default text for share status filter',
      })
    : visibility === 'PRIVATE'
      ? intl.formatMessage({
          id: 'SearchAndFilters.shareStatusMine',
          defaultMessage: 'Share status is Mine',
          description: 'Text when share status filter is set to Mine',
        })
      : intl.formatMessage({
          id: 'SearchAndFilters.shareStatusShared',
          defaultMessage: 'Share Status is Shared',
          description: 'Text when share status filter is set to Shared',
        });

  return (
    <Layout direction="column" spacing={2}>
      <TextInput
        name="search question groups"
        placeholder={intl.formatMessage({
          id: 'SearchAndFilters.searchPlaceholder',
          defaultMessage: 'Search',
          description: 'Placeholder text for search input',
        })}
        value={search}
        onChange={(value) => onSearch(value ?? '')}
      />
      {onFilter && (
        <BaseFilter<Nullable<ShareFilters>>
          name="share filter"
          value={visibility}
          onChange={onFilter}
          options={[
            {
              label: intl.formatMessage({
                id: 'SearchAndFilters.mineOption',
                defaultMessage: 'Mine',
                description: 'Option label for private/mine filter',
              }),
              value: 'PRIVATE',
            },
            {
              label: intl.formatMessage({
                id: 'SearchAndFilters.sharedOption',
                defaultMessage: 'Shared',
                description: 'Option label for shared filter',
              }),
              value: 'SHARED',
            },
          ]}
          filterText={visibilityText}
        />
      )}
    </Layout>
  );
};
